// extracted by mini-css-extract-plugin
export default {"container":"modal_container__QZsww","success":"modal_success__5u9oP","error":"modal_error__2EVAy"};